/** Calendar-day helpers that avoid UTC shifting on date-only values. */

/** Today's calendar date in US Eastern, matching DateTimeHelper.Today on the API. */
export function todayEstKey(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(now);
  const year = parts.find(part => part.type === 'year')?.value;
  const month = parts.find(part => part.type === 'month')?.value;
  const day = parts.find(part => part.type === 'day')?.value;
  return `${year}-${month}-${day}`;
}

export function todayEst(now: Date = new Date()): Date {
  return parseDateOnly(todayEstKey(now))!;
}

export function toDateKey(value: Date | string | null | undefined): string | null {
  if (value == null || value === '') {
    return null;
  }

  if (value instanceof Date) {
    if (isNaN(value.getTime())) {
      return null;
    }
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : toDateKey(parsed);
}

export function parseDateOnly(value: Date | string | null | undefined): Date | null {
  const key = toDateKey(value);
  if (!key) {
    return null;
  }
  const [year, month, day] = key.split('-').map(Number);
  return new Date(year, month - 1, day);
}
